module.exports = __webpack_public_path__ + "8d85770e106a560ad471f1e9b1908274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/4-star.svg
// module id = 976
// module chunks = 0